import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { EasterEggs, LocalStorageEasterEgg } from "abreact/app/easterEggs/EasterEggs";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ProductCapability } from "abweb/dto/product/ProductCapability";
import { AbWebServices } from "abweb/service/AbWebServices";
import { AbstractUserSetting } from "abweb/service/settings/UserSetting";
export let ColorSchemeSettings = /*#__PURE__*/function (ColorSchemeSettings) {
  ColorSchemeSettings["LIGHT_MODE"] = "ab-light-mode";
  ColorSchemeSettings["DARK_MODE"] = "ab-dark-mode";
  return ColorSchemeSettings;
}({});
class AlternativeColorSchemesEasterEgg extends LocalStorageEasterEgg {
  constructor() {
    super("AlternativeColorSchemes", "Alternative color schemes (experimental)");
  }
}

/**
 * A simple setting for managing the user's preferred color scheme.
 */
export class ColorSchemeUserSetting extends AbstractUserSetting {
  constructor() {
    super("ColorScheme");
    _defineProperty(this, "defaultValue", ColorSchemeSettings.LIGHT_MODE);
    _defineProperty(this, "alternativeColorSchemesEasterEgg", new AlternativeColorSchemesEasterEgg());
  }
  get isAvailable() {
    // Note: we are not supporting the color scheme picker in GA1, unless the easter egg is enabled
    return this.alternativeColorSchemesEasterEgg.isEnabled() || AbWebServices.sessionData.productInfo.hasCapability(ProductCapability.GA2_EXPERIENCE);
  }
  async initialize() {
    const initialized = await super.initialize();
    if (initialized && this.value) {
      this.onValueChange(this.value);
    }

    // Register the easter egg
    EasterEggs.registry.register(() => this.alternativeColorSchemesEasterEgg);
    return initialized;
  }
  get displayName() {
    return AbReactResources.userSetting_colorScheme_displayName();
  }
  get values() {
    return [{
      value: ColorSchemeSettings.LIGHT_MODE,
      displayName: AbReactResources.userSetting_colorScheme_lightMode()
    }, {
      value: ColorSchemeSettings.DARK_MODE,
      displayName: AbReactResources.userSetting_colorScheme_darkMode()
    }];
  }
  onValueChange(value) {
    if (value === ColorSchemeSettings.DARK_MODE.valueOf()) {
      document.documentElement.classList.add(ColorSchemeSettings.DARK_MODE.valueOf());
      document.documentElement.classList.remove(ColorSchemeSettings.LIGHT_MODE.valueOf());
    } else {
      document.documentElement.classList.add(ColorSchemeSettings.LIGHT_MODE.valueOf());
      document.documentElement.classList.remove(ColorSchemeSettings.DARK_MODE.valueOf());
    }
  }
}
//# sourceMappingURL=ColorSchemeUserSetting.js.map
